import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DriverForm } from 'components/forms';
import { getDriverByID } from 'store/driverSlice';
import { search_type } from 'utils';
import { getVendorList } from 'store/vendorSlice';
// import { getVehicalList } from 'store/vehicleSlice';

export default function CreateDriver() {
	const [formData, setFormData] = useState({});
	const [vendorListdata, setVendorListdata] = useState([]);
	// const [vehicalListdata, setVehicalListdata] = useState([]);
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		if (id) {
			dispatch(
				getDriverByID({
					search_type: search_type?.driver,
					filter_by: {
						id,
					},
				})
			).then((res) => {
				console.log(res);
				setFormData(res?.rows?.[0]);
			});
		}
		dispatch(
			getVendorList({
				search_type: 'vendor',
				filter_by: {
					vendor_type: 'regular',
				},
			})
		)
			.then((res) => {
				const data = res?.rows?.map((item) => ({
					value: item?.id,
					label: item?.vendor_info?.vendor_name,
					item,
				}));
				setVendorListdata(data);
			})
			.finally(() => {});
		// dispatch(
		// 	getVehicalList({
		// 		search_type: 'vehicle',
		// 	})
		// )
		// 	.then((res) => {
		// 		const vtypedata = res?.rows?.map((item) => ({
		// 			value: item?.id,
		// 			label: item?.vehicle_type,
		// 			item,
		// 		}));
		// 		setVehicalListdata(vtypedata);
		// 	})
		// 	.finally(() => {});
	}, [dispatch, id]);

	console.log('id', id);
	return (
		<DriverForm
			isEditMode={Boolean(formData?.id)}
			formData={formData}
			vendorData={vendorListdata}
			// vechicalData={vehicalListdata}
		/>
	);
}
